import {
  convertEventSelectToTarget,
  formatDataToLabelValue,
  Select,
  STATUSPAGE,
} from '@repo/ui';
import {
  GetAllCurricularUnitsUserResponse,
  GetAllGroupsUserResponse,
  GetAllProfessionalsSelectOptionsResponse,
  GetAllSemestersUserResponse,
} from 'domain/models';
import { FormikProps } from 'formik';
import { Option } from 'presentation/app/models/option';
import { Col, Form, Input, Label, Row, Spinner } from 'reactstrap';

const PERIOD_TYPE_OPTIONS = [
  { label: 'Data da atividade', value: 'ACTIVITY_DATE' },
  { label: 'Data de validação', value: 'VALIDATION_DATE' },
];

interface IDailyWorkloadFiltersValues {
  startDate: string;
  endDate: string;
  periodType: 'ACTIVITY_DATE' | 'VALIDATION_DATE';
  semester: Option | null;
  unit: Option | null;
  group: Option | null;
  professional: Option | null;
  search: string;
}

interface IProps {
  validation: FormikProps<IDailyWorkloadFiltersValues>;
  semesters: GetAllSemestersUserResponse[];
  curricularUnits: GetAllCurricularUnitsUserResponse[];
  groups: GetAllGroupsUserResponse[];
  professionals: GetAllProfessionalsSelectOptionsResponse[];
  statusGet: STATUSPAGE;
}

export const DailyWorkloadFiltersForm = ({
  validation,
  semesters,
  curricularUnits,
  groups,
  professionals,
  statusGet,
}: IProps) => {
  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
      }}
    >
      <Row>
        <Col md={6} lg={4} className="mb-3">
          <Label className="form-label">Tipo de período</Label>
          <Select
            name="periodType"
            value={
              PERIOD_TYPE_OPTIONS.find(
                (o) => o.value === validation.values.periodType,
              ) ?? null
            }
            onChange={(value) =>
              validation.setFieldValue(
                'periodType',
                (value as Option)?.value ?? 'ACTIVITY_DATE',
              )
            }
            options={PERIOD_TYPE_OPTIONS}
          />
        </Col>

        <Col md={6} lg={2} className="mb-3">
          <Label htmlFor="startDate" className="form-label">
            Data inicial
          </Label>
          <Input
            type="date"
            id="startDate"
            name="startDate"
            value={validation.values.startDate}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
          />
        </Col>

        <Col md={6} lg={2} className="mb-3">
          <Label htmlFor="endDate" className="form-label">
            Data final
          </Label>
          <Input
            type="date"
            id="endDate"
            name="endDate"
            value={validation.values.endDate}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
          />
        </Col>

        <Col md={6} lg={4} className="mb-3">
          <Label className="form-label">Semestre</Label>
          <Select
            isClearable
            name="semester"
            value={validation.values.semester}
            placeholder="Todos"
            onChange={(value) =>
              validation.handleChange(
                convertEventSelectToTarget('semester', value),
              )
            }
            options={formatDataToLabelValue(semesters as never, 'id', 'nome')}
          />
        </Col>

        <Col md={6} lg={4} className="mb-3">
          <Label className="form-label">Unidade Curricular</Label>
          <Select
            isClearable
            name="unit"
            value={validation.values.unit}
            placeholder="Todos"
            onChange={(value) =>
              validation.setFieldValue('unit', value || null)
            }
            options={formatDataToLabelValue(
              curricularUnits as never,
              'id',
              'nome',
            )}
          />
        </Col>

        <Col md={6} lg={4} className="mb-3">
          <Label className="form-label">Grupo</Label>
          <Select
            isClearable
            name="group"
            value={validation.values.group}
            placeholder="Todos"
            onChange={(value) =>
              validation.setFieldValue('group', value || null)
            }
            options={formatDataToLabelValue(groups as never, 'id', 'nome')}
          />
        </Col>

        <Col md={6} lg={4} className="mb-3">
          <Label className="form-label">Profissional</Label>
          <Select
            isClearable
            name="professional"
            value={validation.values.professional}
            placeholder="Todos"
            onChange={(value) =>
              validation.setFieldValue('professional', value || null)
            }
            options={formatDataToLabelValue(
              professionals as never,
              'id',
              'name',
            )}
          />
        </Col>
      </Row>

      <div className="d-flex justify-content-end">
        <button
          type="submit"
          className="btn btn-primary waves-effect waves-light"
          disabled={statusGet === STATUSPAGE.LOADING}
        >
          {statusGet === STATUSPAGE.LOADING ? (
            <Spinner size="sm">Carregando...</Spinner>
          ) : (
            <>
              Filtrar
              <i className="ri-computer-line mx-2" />
            </>
          )}
        </button>
      </div>
    </Form>
  );
};
